<template>
    <div class="p-5 mt-5">
        <a-form :form="form" style="width: 600px;margin: auto">

            <a-form-item label="供应商类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-radio-group :disabled="true"  v-decorator="['supplierType',{initialValue:en.supplierType,rules: [{message:'请选择供应商类型',required: true}]}]">
                    <a-radio value="2">
                        法人供应商
                    </a-radio>
                    <a-radio value="1">
                        个体户供应商
                    </a-radio>
                </a-radio-group>
            </a-form-item>

            <a-form-item label="单位名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input-group style="display: inline-block; vertical-align: middle" :compact="true">
                    <a-input v-decorator="['enterpriseName',{initialValue: en.enterpriseName, rules: [{ required: true, message: '单位名称不能为空'}]}]"/>
                </a-input-group>
            </a-form-item>
            <a-form-item label="统一信用代码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input :disabled="true" v-decorator="['enterpriseCode',{initialValue: en.enterpriseCode, rules: [{message: '请输入正确信用编码', required: true, pattern: /[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}/g }]}]"/>
            </a-form-item>
            <a-form-item class="text-center mb-0">
                <a-button style="width: 200px" type="primary"  @click="nextStep">下一步</a-button>
            </a-form-item>
        </a-form>

        <div class="step-form-style-desc">
        </div>
    </div>
</template>

<script>
    import qs from "qs";

    export default {
        created() {
            this.initData()
            // this.getAccountInfo()
        },
        name: 'ModifyStep1',
        data () {
            return {
                labelCol: { lg: { span: 5 }, sm: { span: 5 } },
                wrapperCol: { lg: { span: 19 }, sm: { span: 19 } },
                form: this.$form.createForm(this),
                en:'',
                supplierCode:''
            }
        },
        methods: {
            initData() {
                let that = this
                this.$http.get("/api/v1/supplier/enterprise/getModifyInitInfo.json").then(function (res) {
                    that.en = res.result//getModifyInitInfo
                    if (that.en.status === '1') {
                        that.$success({
                            title: '提示',
                            content: '单位信息变更审核中',
                            okText: '确定',
                            onOk:function () {
                                that.$router.push({path:'/account/AccountManage'})
                            }
                        })
                    }else if (that.en.status === '3') {
                        that.$success({
                            title: '审核结果提示',
                            content:'审核不通过；'+ (that.en.opinion ? ('意见:' + that.en.opinion) :'') ,
                            okText: '确定'
                        })
                    }
                });
            },
            // getAccountInfo() {
            //     let that = this
            //     this.$http.get('/api/v1/supplier/getAccountInfo.json').then(function (res) {
            //         if (res.result.supplierType === '1') {
            //             that.$router.push({path: '/enterprise/NatureAuthChange'});
            //         }
            //     });
            // },
            nextStep () {
                let params = {...this.form.getFieldsValue()}
                this.form.validateFields((err, values) => {
                    if (err) {
                        return
                    }
                    var params2 = {}
                    params2.supplierCode =  params.enterpriseCode
                    let that = this
                    that.$emit("commitValue",params.enterpriseCode,params.enterpriseName,params.supplierType)
                    that.$emit('nextStep')
                    // that.$emit('clickSupplier',params.supplierType)
                });
            },
            codeInfo(value) {
                let that = this
                this.$confirm({
                    title: '提示',
                    content: value+'统一信用编码已被认证,请重新填写,或者关联该企业',
                    okText: '关联该企业',
                    okType: 'primary',
                    cancelText: '重新填写',
                    onOk() {
                        console.log('关联该企业...'+value);
                        that.$router.push({path:'/enterprise/ConnectSupplier?supplierCode='+value})
                    },
                    onCancel() {
                        console.log('Cancel');
                    },
                })
            },
            sysInfo(value) {
                this.$success({
                    title: '提示',
                    content:value
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .step-form-style-desc {
        padding: 0 56px;
        color: rgba(0,0,0,.45);

        h3 {
            margin: 0 0 12px;
            color: rgba(0,0,0,.45);
            font-size: 16px;
            line-height: 32px;
        }

        h4 {
            margin: 0 0 4px;
            color: rgba(0,0,0,.45);
            font-size: 14px;
            line-height: 22px;
        }

        p {
            margin-top: 0;
            margin-bottom: 12px;
            line-height: 22px;
        }
    }
</style>
